<template>
	<TopTab />
	<van-swipe class="my-swipe" :autoplay="3000" :show-indicators="false">
		<van-swipe-item v-for="item in bannerList" :key="item.id">
			<div class="banner" :style="{ backgroundImage: `url(${item.carouselImg})` }"></div>
		</van-swipe-item>
	</van-swipe>
	<div class="culture-container">
		<div>
			<h4>BRAND 品牌介绍</h4>
			<h5>九色鹿-艺术品科技超选平台（jiuselu.net）</h5>
			<p>九色鹿（jiuselu.net）是湖南九色文化科技有限公司旗下文化艺术O2O创新业态平台，是国内领先的艺术品超级优选服务机构，向艺术家、收藏家和收藏机构提供优质的数字化空间虚拟艺术馆，为艺术消费者提供立体的艺术品虚拟选购空间。我们通过互联网数字科技，将艺术家作品实物生成数字作品，搭建虚拟现实艺术馆。搭建全新的数字化、沉浸式艺术展示交流空间。打通实物作品数字化呈现，立体的虚拟感受空间，再以线下直营科技艺术馆进行实物作品展览。倾力打造世界一流的集文化艺术展览、文化宣传交流、文化教育、艺术品综合交易、保护为一体的综合性艺术创新平台。
				<br />
				在全国多个地区设有线下直营科技艺术馆，单个艺术馆面积约2000平方米。设有前厅、休憩区、洽谈区、艺术展区、综合展示区、邮票钱币区、文创产品区、活动区。艺术品收藏爱好者可在此欣赏到多样化的各类名家艺术作品。并不定时举行各类线下艺术交流活动，并提供专业、全面的一站式艺术品综合服务，竭力推动艺术家、艺术爱好者、艺术市场间的良好交流发展，弘扬中国优秀文化。
			</p>

			<img src="@/assets/imgs/bg2.png" class="bg" style="margin-top: 20rem;">
		</div>
		<div class="p2">
			<h4>BRAND 品牌故事</h4>
			<img src="@/assets/imgs/bg3.png" class="bg">
			<p>九色鹿为敦煌瑞兽，来自于璀璨的敦煌文化《鹿王本生图》。敦煌是古丝绸之路上的“咽喉之地”，自汉代以来两千多年的历史长河中，敦煌始终以中华传统文明为根基，多元文化在此交流、碰撞、融合、发展，孕育出多姿多彩、丰润厚重的敦煌文化。同时又闪耀着古代印度文明、波斯文明、希腊文明的璀璨光芒，成为举世瞩目、特色鲜明、多元一体的地域文化。是各种文明长期交流融合的结晶，展示了中华民族的文化自信。 相传，鹿王身上的毛有九种颜色，鹿角白如雪，鹿王只要一站着不动，就能看到它身体闪着七彩光。他在江边救了一个快要溺水而亡的人。被救的人要给鹿王为奴，鹿王拒绝了并叮嘱他说，“如果将来有人要捕我，你不要说见到过我。”但当国王悬赏时，被救的人贪图财富还是向国王报告了九色鹿王的行踪。在包围中，九色鹿跳到国王面前，讲述了救人与遭人背叛的经过，国王听后放了鹿王，坏人也得到了惩罚。故事体现了九色鹿忘我奉献、仁义助人的精神。有诗云：国王逐鹿识人心，恩爱不如兽与禽。世上能呼知识醒，水中能救欲溺身。 梦回敦煌，一舞千年；<br /> 星转斗移，承古烁今，九色鹿踏歌飞舞而来，身披五千年文化的七彩光芒，全新演绎。化身传播中国文化的使者，带来千古人文的璀璨明珠。让人们的生活更加炫丽多彩、丰润美好。化形于现代科技艺术场馆，古今人文情愫相织交替，包罗万象，仁义助人。为人们甄选极具中国文化元素的文化产品、艺术品。弘扬中国文化，传递人文价值、艺术价值和经济价值，让世界爱上中国。
			</p>
		</div>
	</div>
	<div class="p3">
		<h4>BRAND 品牌文化</h4>
		<ul>
			<li>
				<img src="@/assets/imgs/icon24.png" alt="">
				<h6>价值理念</h6>
				<p>只为传递世间美好</p>
			</li>
			<li>
				<img src="@/assets/imgs/icon22.png" alt="">
				<h6>品牌理念</h6>
				<p>匠心铸就品质专注成就非凡</p>
			</li>
			<li>
				<img src="@/assets/imgs/icon25.png" alt="">
				<h6>品牌愿景</h6>
				<p>让艺术收藏变的简单和高效</p>
			</li>
			<li>
				<img src="@/assets/imgs/icon21.png" alt="">
				<h6>建设目标</h6>
				<p>成为世界一流艺术收藏品综合服务运营商</p>
			</li>
		</ul>
	</div>
	<div class="line"></div>
	<h4>BRAND 企业文化</h4>
	<div class="p4">
		<img src="@/assets/imgs/bg4.png" class="bg">
		<h6>使命</h6>
		<p>传播中国文化，让世界爱上中国!</p>
		<h6>经验理念</h6>
		<p>一切以客户价值需求为依归!</p>
		<h6>使命</h6>
		<p>通过科技赋能，线上线下联动。已为数百万艺术收藏爱好者提供服务，帮助千万用户打造品质艺术生活!</p>
	</div>
	<div class="line"></div>
	<h4>BRAND 服务内容</h4>
	<div class="p5">
		<div>
			<img src="@/assets/imgs/bg8.png" alt="">
			<p>举办主题性大型展览与大师回顾展，呈现顶尖艺术珍品。设立多元常设展与科技艺术体验，打造沉浸式观展旅程。</p>
		</div>
		<div>
			<img src="@/assets/imgs/bg5.png" alt="">
			<p>通过多元化的学术与社交活动，深化艺术的内涵、促进跨文化、跨领域的对话，推动艺术普及与灵感碰撞。</p>
		</div>
		<div>
			<img src="@/assets/imgs/bg6.png" alt="">
			<p>通过独家体验与专属服务，将艺术融入其生活方式提升藏家与艺术爱好者的参与感和归属感。</p>
		</div>
		<div>
			<img src="@/assets/imgs/bg7.png" alt="">
			<p>打造了一个透明、可靠、服务周到的线上+线下艺术市场为买卖双方，提供专业的交易保障与资产配置服务。</p>
		</div>
	</div>
	<div class="line"></div>
	<h4>BRAND 我们的优势</h4>
	<div class="p6">
		<div>
			<img src="@/assets/imgs/bg9.png" alt="">
			<h6>丰富·艺术品资源</h6>
			<p>以强大的全球艺术资源为依托，<br/>严格甄选上万件原创艺术作品，<br/>类型涵盖油画、版画、雕塑、水墨、书法等。<br/>为您提供庞大的艺术资产库。</p>
		</div>
		<div>
			<img src="@/assets/imgs/bg11.png" alt="">
			<h6>专业·艺术品顾问</h6>
			<p>以专业、学术的资深艺术专家团队为依托，<br/>服务于艺术品专业及真假鉴定等能力，<br/>为您全方位的提供艺术品收藏、<br/>艺术品交易等服务。</p>
		</div>
		<div>
			<img src="@/assets/imgs/bg9.png" alt="">
			<h6>无忧·一站式体验</h6>
			<p>以远瞻性的前沿技术打造的艺术互联网产品为依托，强大的艺合能力为您提供最为便捷的艺术服务全产业链生态。一切轻松实现，满足您对艺术的每个需。</p>
		</div>
	</div>
</template>

<script setup>
import TopTab from '@/views/front/components/TopTab.vue'
import { onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'
import * as api from '@/request/front'
const bannerList = ref([])
onMounted(() => {
	api.getBannerList(264).then(res => {
		bannerList.value = res.data.rows
	})
})
const router = useRouter()
const loading = ref(false)
const finished = ref(false)

</script>

<style scoped lang="scss">
.my-swipe {
	width: 100%;
	height: 160rem;

	.banner {
		width: 100%;
		height: 100%;
		background-size: cover;
		background-position: center;
	}
}

h4 {
	margin: 30rem 0;
	text-align: center;
}

h5 {
	margin-bottom: 10rem;
}

p {
	line-height: 24rem;
}

.p2 {
	p {
		padding: 20rem;
	}
}

.p3 {
	padding: 15rem;

	ul {
		display: flex;
		justify-content: space-between;

		li {
			width: 80rem;
			display: flex;
			flex-direction: column;
			align-items: center;

			img {
				width: 40rem;
				height: 40rem;
			}

			h6 {
				font-size: 12rem;
				margin: 10rem 0;
			}

			p {
				line-height: 14rem;
				font-size: 10rem;
				color: #717171;
				text-align: center;
			}
		}
	}
}

.p4 {
	margin: 15rem;
	background-color: #F8F8F8;
	display: flex;
	flex-direction: column;
	align-items: center;
	padding-bottom: 40rem;

	p {
		font-size: 12rem;
		color: #717171;
		width: 60%;
		line-height: 18rem;
		text-align: center;
	}

	h6 {
		margin: 20rem 0;
	}
}


.p5 {
	display: flex;
	justify-content: space-between;
	flex-wrap: wrap;
	padding: 0 15rem;

	>div {
		width: 190rem;
		margin: 10rem 0;

		img {
			width: 100%;
			height: 267rem;
		}

		p {
			font-size: 12rem;
			line-height: 18rem;
			color: #717171;
			margin-top: 5rem;
			font-family: '微软雅黑';
		}
	}
}

.p6{
	display: flex; flex-direction: column; align-items: center;
	>div{
		display: flex; flex-direction: column; align-items: center; margin-top: 50rem;
		img{
			width: 250rem; height: 250rem;
		}
		h6{width: 260rem; text-align: center; margin-top: 20rem;}
		p{width: 260rem; text-align: center; font-size: 12rem; line-height: 18rem; color: #717171; margin-top: 10rem;}
	}
}

.line {
	width: 96%;
	margin: 0 2%;
	height: 1rem;
	background-image: url('@/assets/imgs/line.png');
	background-size: 100%;
}

.bg {
	width: 100%;
}

.culture-container {
	background-color: #F8F8F8;
	margin: 0 10rem;
	padding: 20rem 10rem;


}
</style>
